import marketFiltersMixin from '@/components/market/market-filters/market-filters-mixin/market-filters-mixin';

export default {
  mixins: [
    marketFiltersMixin,
  ],
  computed: {
    mainClassName() {
      return 'market-filters-desktop-grid';
    },
    menuClassModifier() {
      return {
        'market-filters-desktop-grid__menu': true,
        'market-filters-desktop-grid__menu--with-timespan-filter': this.shouldShowTimespanFilter,
      };
    },
    orderMenuName() {
      return this.selectedOrder.fullName;
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/market/market-filters/market-filters-desktop-grid/market-filters-desktop-grid.js